import { createUrlBuilder, joinPaths } from '@utils/buildUrl';
import { getDefined } from '../defined';
import { createUrlFromHostname } from '@utils/url';

import type { StringifiableRecord } from 'query-string';

const apiUrlBuilder = createUrlBuilder(() =>
  createUrlFromHostname(getDefined('PUBLIC_FLEEK_REST_API_HOST')),
);

export const getApiUrl = (
  path: string,
  version: 1 | 2,
  params?: {
    pathParams?: Record<string, string | string[]>;
    queryParams?: StringifiableRecord;
  },
): string => apiUrlBuilder(joinPaths('/api', `v${version}`, path), params);
